import dayjs from 'dayjs'

import { getServerNow } from '@/components/entities/common/model/server-time'
import { DEFAULT_TIMEZONE } from '@/components/entities/requests/model/constants'
import { toMskCalendarDate, toMskCalendarDay } from '@/utils/datetime'

export { toMskCalendarDay } from '@/utils/datetime'

export const mskNow = () => dayjs(getServerNow()).tz(DEFAULT_TIMEZONE)

export const getMskCalendarToday = () => toMskCalendarDate(getServerNow())

export const toApiUtcDateTime = (date?: Date) =>
  dayjs(date).toDate().toISOString().replace('.000Z', 'Z')

export const toApiDate = (date?: Date) => dayjs(date).format('YYYY-MM-DD')

export const getMonthSlotsRange = (date: Date) => ({
  from: dayjs(date)
    .startOf('month')
    .startOf('isoWeek')
    .subtract(1, 'day')
    .format('YYYY-MM-DD'),
  to: dayjs(date).endOf('month').endOf('isoWeek').format('YYYY-MM-DD')
})

export const getDaySlotsRange = (date: Date) => ({
  from: dayjs(date).subtract(1, 'day').format('YYYY-MM-DD'),
  to: dayjs(date).format('YYYY-MM-DD')
})

export const getDailyPeriodStart = (date: Date) =>
  toMskCalendarDay(date).startOf('day').toDate()

export const getDailyPeriodEnd = (date: Date) =>
  toMskCalendarDay(date).endOf('day').toDate()

// для инпута нужен день окончания в московском часовом поясе, но
// отформатированный без конвертации (иначе браузер в другом поясе снова
// сдвинет число при выводе) - поэтому переносим msk-дату в локальную полночь
export const toDailyInputDisplayDate = (date: Date) =>
  dayjs(toMskCalendarDay(date).endOf('day').format('YYYY-MM-DD')).toDate()
